import React from "react";
import Modal from "react-modal";
import { HiX } from "react-icons/hi";

Modal.setAppElement("#root");

type PROPS = {
  modalIsOpen: boolean;
  message?: string;
  action?: (result: boolean) => void;
};

const ConfirmDialog: React.FC<PROPS> = (props) => {
  const modalStyle: Modal.Styles = {
    overlay: {
      backgroundColor: "rgba(0,0,0,0.60)",
    },
    content: {
      right: "unset",
      bottom: "unset",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: "16px",
    },
  };

  const close = (result = false) => {
    if (props.action) {
      props.action(result);
    }
  };

  return (
    <Modal
      isOpen={props.modalIsOpen}
      onRequestClose={() => close()}
      style={modalStyle}
    >
      <div className="flex justify-between items-center gap-4">
        <div className="font-bold text-xl"></div>
        <div
          className="p-1 rounded cursor-pointer hover:bg-gray-300"
          onClick={() => close()}
        >
          <HiX />
        </div>
      </div>
      <div className="p-2">{props.message}</div>
      <div className="flex justify-center gap-4 mt-4">
        <button className="primary px-4 py-2" onClick={() => close(true)}>
          はい
        </button>
        <button className="primary px-4 py-2" onClick={() => close()}>
          いいえ
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmDialog;
